module.exports = __webpack_public_path__ + "img/3.a3b4dc8f.png";